<template>
  <div
    v-if="this.$store.getters['authorization/acl'].hasPermission('address_book_access')"
    class="PlatformAddressBookView"
  >
    <ShPageHeader
      :breadcrumb-items="[
        { label: 'zarządzanie' },
        { label: 'książka adresowa', path: '/addressbook' }
      ]"
      description="Książka adresowa przypisana do projektów użytkownika"
      title="Książka adresowa"
    />
    <AddressBook
      :address-book="addresslist"
      :agentsList="agentsBelongsToUserAgents"
      @openCreationFormModal="toggleCreationFormModal"
    />
    <ShSideBarModal
      v-if="$store.getters['authorization/acl'].hasPermission('address_book_create')"
      :description="'Uzupełnij poniższy formularz aby dodać nowy numer do książki adresowej'"
      :side-bar-modal-visibility.sync="isSideBarModalVisibility"
      :title="'Formularz przypisywania nowego numeru'"
      @closeModal="toggleCreationFormModal"
    >
      <AddressBookAddNewNumberForm
        slot="content"
        :project-list="projectsList"
        @closeModal="toggleCreationFormModal"
        @refreshList="getAddressList"
      />
    </ShSideBarModal>
  </div>
</template>

<script>
import { hDeepCopy } from "@/utils/helpers";
import AddressBook from "../components/AddressBook";
import AddressBookAddNewNumberForm from "../components/AddressBook/AddressBookAddNewNumberForm";

export default {
  name: "PlatformAddressBook",
  components: {
    AddressBook,
    AddressBookAddNewNumberForm
  },

  data() {
    return {
      isSideBarModalVisibility: false
    };
  },

  computed: {
    projectsList() {
      return this.$store.getters["client/projects/list"].records;
    },
    userData() {
      return this.$store.getters["authorization/user"];
    },
    addresslist() {
      return hDeepCopy(this.$store.getters["addressBook/list"]);
    },
    agentsBelongsToUserAgents() {
      return hDeepCopy(
        this.$store.getters["user/agent/agentsBelongsToUserlist"].records.filter(
          el => el.massdial4call === true
        )
      );
    }
  },

  async created() {
    await this.getAddressList();
    await this.$store.dispatch("client/projects/getList", this.userData.client.client_uuid);
  },

  methods: {
    async getAddressList() {
      await this.$store.dispatch("addressBook/getList");
    },
    toggleCreationFormModal() {
      this.isSideBarModalVisibility = !this.isSideBarModalVisibility;
    }
  }
};
</script>

<style lang="sass" scoped>
.PlatformAddressBookView
</style>
